import { useMemo } from 'react';
import { FTU_WIZARD_STEPS, VIEW_TYPES } from '../constants';

export const useViewType = (currentStepKey, wizardData, currentStep, totalWizardPages) => {
  const currentViewType = useMemo(() => {
    switch (currentStepKey) {
      case FTU_WIZARD_STEPS.ORDERS:
        return wizardData.hasStores ? VIEW_TYPES.CONFIGURED : VIEW_TYPES.SETUP;
      case FTU_WIZARD_STEPS.SHIP_FROM:
        return wizardData.hasShipFroms ? VIEW_TYPES.CONFIGURED : VIEW_TYPES.SETUP;
      case FTU_WIZARD_STEPS.CARRIER:
        return wizardData.hasWallet ? VIEW_TYPES.CONFIGURED : VIEW_TYPES.SETUP;
      case FTU_WIZARD_STEPS.DISCOUNTED_RATES:
        return VIEW_TYPES.CONFIGURED;
      case FTU_WIZARD_STEPS.INVENTORY_SETUP:
        if (!wizardData.hasInventorySetup) return VIEW_TYPES.SETUP;
        if (currentStep === totalWizardPages) return VIEW_TYPES.FINAL;
        return VIEW_TYPES.CONFIGURED;
      default:
        return VIEW_TYPES.SETUP;
    }
  }, [currentStepKey, wizardData, currentStep, totalWizardPages]);

  const isLastStep = currentStep === totalWizardPages;

  return {
    currentViewType,
    isLastStep,
  };
};
